var imgsrcs = {
    smallSrcs: [{
        src: require('../img/small1.jpg'),
        isBlur: true,
        title: "第一张",
        desc: "蓝天白云"
    }, {
        src: require('../img/small2.jpg'),
        isBlur: true,
        title: "第二张",
        desc: "青山草地"
    }, {
        src: require('../img/small3.jpg'),
        isBlur: true,
        title: "第三张",
        desc: "白雪皑皑，枯树蓝天。"
    }],
    bigSrcs: ['http://p3.music.126.net/nN_ndoChgRbzHpchrlS0Lw==/1364493956148099.jpg',
        'http://sc.jb51.net/uploads/allimg/121104/2-121104100944K2.jpg',
        'http://image.photophoto.cn/nm-23/097/016/0970160063.jpg'
    ]
};

export default imgsrcs;



/** WEBPACK FOOTER **
 ** ./src/data/imgsrcs.js
 **/